const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfCulture extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfCulture,
            "Civilizations score culture based on the relative amount of culture they produce:\n" + 
            "4 players: 15/10/5/0 culture;\n" + 
            "3 players: 14/7/0 culture;\n" + 
            "2 players: 10/0 culture;\n" + 
            "Those who played last lose ties",
            {}
        )
    }
}

module.exports = ImpactOfCulture;